import React from 'react';
import { EditWithIcon, SimpleTooltip, TextRow } from 'components';
import { Images } from 'utils';

export const banksHead = [
    { name: 'name', title: 'Bank Name', custom: false },
    // { name: '', title: 'Account Holder', custom: false },
    { name: 'accountNumber', title: 'Account Number', custom: false },
    { name: 'routingNumber', title: 'Routing Number', custom: false },
    { name: 'address', rowName: 'formattedAddress', title: 'Bank Address' },
    { name: '', title: 'Action', custom: false, width: '150px' },
];

export const banksBody = [
    {
        rowText: (item) => (
            <div className="flex-align-center" style={{ gap: 4 }}>
                <TextRow name={item?.name} wrapperStyle={{ width: 'auto' }} />
                {item?.default && (
                    <SimpleTooltip title={'Default Bank Account'} placement="bottom" arrow>
                        <img src={Images.defaultBadge} alt="defaultBank" />
                    </SimpleTooltip>
                )}
            </div>
        ),
    },
    // { rowText: (item) => <TextRow name={item?.accountHolderName} /> },
    { rowText: (item) => <TextRow name={item?.accountNumber} /> },
    { rowText: (item) => <TextRow name={item?.routingNumber} /> },
    { rowText: (item) => <TextRow name={item?.address?.formattedAddress} /> },
    {
        button: (cb, item) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <EditWithIcon icon={Images.editAuth} type={'button'} handleClick={() => cb('edit')} />
                {/*<EditWithIcon*/}
                {/*    icon={Images.deleteTag}*/}
                {/*    type={'button'}*/}
                {/*    handleClick={() => cb('delete')}*/}
                {/*/>*/}
            </div>
        ),
        notClickable: true,
    },
];

export const banksNotYet = {
    title: 'No Banks Added Yet',
    subTitle: 'Start adding bank.',
    image: Images.noClientYet,
};

export const BANK_ACTION_TYPE = 'GET_BANKS';
